(function() {
	'use strict';
	angular.module('paymentRates').controller('flyingHoursRangePopupCtrl',
			flyingHoursRangePopupCtrl);

	function flyingHoursRangePopupCtrl($uibModalInstance, modalParams,
			MessageService, EventManagerService, PopupManager) {
		var vm = this;

		vm.model = {
			rangeDetails : {
				'rangeTitle' : modalParams.rangeTitle,
				'fromHour' : modalParams.fromHour,
				'toHour' : modalParams.toHour,
				'range' : modalParams.range,
				'showDeleteRangeButton' : modalParams.showDeleteButton,
				'rowIndex' : modalParams.rowIndex,
				'paymentHourRangeId' : modalParams.paymentHourRangeId,
				'version' : modalParams.version,
				'crewTypeCode' : modalParams.crewTypeCode
			}
		};

		vm.onCloseClick = function() {
			PopupManager.closeModal('ADD_FLYING_HOURS_RANGE');
		};

		vm.onDeleteRange = function() {
			EventManagerService.notifyEventListeners(
					EventManagerService.EVENT.PAYMENT_RATES.DELETE_RANGE,
					vm.model.rangeDetails);
		}

		vm.onApplyAddRangeData = function() {
			if (vm.model.rangeDetails.rangeTitle
					&& (vm.model.rangeDetails.fromHour || vm.model.rangeDetails.fromHour == 0)
					&& (vm.model.rangeDetails.range || vm.model.rangeDetails.range == 0)) {
				EventManagerService.notifyEventListeners(
						EventManagerService.EVENT.PAYMENT_RATES.APPLY_RANGE,
						vm.model.rangeDetails);
			} else {
				MessageService
						.warning(MessageService.MESSAGES.PAYMENT_RATES.POPUP_FORM_ERROR);
			}
		}

		vm.closeMe = function() {
			$uibModalInstance.close();
		};
	}
}());
